module.exports = jsxc;


//////////////////
// WEBPACK FOOTER
// external "jsxc"
// module id = 483
// module chunks = 1